

import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeDocument } from '../../../../shared/models/jobTypeDocument.model';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BillingTask } from '../../../../shared/models/billingTask.model';
import { CostTask } from '../../../../shared/models/costTask.model';
import { Observable } from 'rxjs';






@Component({
  selector: 'app-create-cost-task-widget',
  templateUrl: './create-cost-task-widget.component.html',
  styleUrls: ['./create-cost-task-widget.component.css']
})
export class CreateCostTaskWidgetComponent implements OnInit {

  model: any;
  job_types: any;
  job_type_locations: any;
  count2: any;
  get_latest_court_id: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  get_latest_document_id: any;
  job_type_affidavit_types: any;
  sent_job_type_document_type_id: any;
  get_latest_type_id: any;

  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  myob_account_codes: any;
  myob_tax_codes: any;
  brand_types: any;

  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService, viewRef: ViewContainerRef
  ) { }




  ngOnInit() {
    this.model = new CostTask();

    this.getMyobAccountCodes();
    this.getMyobTaxCodes();
    this.getJobTypes();
    this.getBrandTypes();
    
  }



  createJobType(model) {
    // console.log(model);
        this._demoService.createJobType(model).subscribe(
             data => {  this.get_latest_type_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */

             this.closeParentModel.emit();
   // CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Job Type Failed :: Please try again!');
               // console.log(error(error));
               //return console.log(error);
             }
        );
        }
 
 
        traceAddNotice () {
         this.toastr.info('Job Type Added');
       };
 


createBillingTask(model) {
  this._demoService.createBillingTask(model).subscribe(
    data => {  //this.get_latest_type_id = data; // this is the retuned json upon creation.
      this.closeParentModel.emit();
    },
    error => {
     return console.log(error);
    });
};



createCostTask(model) {
  this._demoService.createCostTask(model).subscribe(
    data => {  //this.get_latest_type_id = data; // this is the retuned json upon creation.
      this.closeParentModel.emit();
    },
    error => {
     return console.log(error);
    });
};



getMyobAccountCodes() {
  this._demoService.getMyobAccountCodes().subscribe(
     data => { this.myob_account_codes = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getMyobTaxCodes() {
  this._demoService.getMyobTaxCodes().subscribe(
     data => { this.myob_tax_codes = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobTypes() {
  this._demoService.getJobTypes().subscribe(
     data => { this.job_types = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getBrandTypes() {
  this._demoService.getBrandBrandTypes().subscribe(
     data => { this.brand_types = data; },
     err => console.error(err),
     // () => console.log('done loading candidate for update')
   );
 }


}
